import {Component} from "@angular/core";

@Component({
    selector: "fui-modal-window-footer",
    styleUrls: ["./modal-window-footer.component.scss"],
    templateUrl: "./modal-window-footer.component.html",
    standalone: false
})
export class FUIModalWindowFooterComponent {
    constructor() {

    }
}
